import React from 'react';
import * as TFF from '@tff/types/TFF';
import { useIntl } from 'react-intl';
import TFFTypography from '../../styled-components/TFFTypography';
import TFFIcon from '../../styled-components/TFFIcon';
import { useBookingContext } from '../../hooks/use-booking-context';
import { isNdcOrNdcxBookingSource } from '../../util/booking-type-utils';

interface props {
  ancillary: TFF.Ancillary;
  isOutbound: boolean;
  bookingSource?: TFF.TffBookingSource;
}

const AncillaryRow: React.FC<props> = ({ ancillary, isOutbound, bookingSource }) => {
  const intl = useIntl();
  const { costFormatter } = useBookingContext();
  const isNdc = bookingSource ? isNdcOrNdcxBookingSource(bookingSource) : false;

  const getNdcAncillaryText = (): string => {
    const defaultAncillaryPieces = ancillary?.AdditionalDetails?.Pieces || 1;
    const baggageSize = ancillary?.Value?.toLowerCase() ?? '';

    switch (ancillary.Type) {
      case 'HAND_BAGGAGE':
        return intl.formatMessage(
          { id: 'ancillary.ndc.handLuggage' },
          { pieces: defaultAncillaryPieces, baggageSize }
        );
      case 'BAGGAGE':
        return intl.formatMessage(
          { id: 'ancillary.ndc.baggage' },
          { pieces: defaultAncillaryPieces, baggageSize }
        );
      default:
        return `${ancillary.Description || ''}${ancillary.Value ? ` (${ancillary.Value})` : ''}`;
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        minWidth: isOutbound ? '340px' : '300px',
      }}
    >
      <TFFTypography
        text={
          <>
            {ancillary.Type === 'SEAT' && (
              <span className="tff-cabin-class-icon">
                <TFFIcon iconName="seat" />
              </span>
            )}
            {isNdc ? (
              getNdcAncillaryText()
            ) : (
              (ancillary.Type.startsWith('BI') || ancillary.TfaDetails) && ancillary.Type !== 'SEAT'
                ? intl.locale === 'en-US'
                  ? ancillary.TfaDetails?.DescriptionEN || ancillary.Value
                  : ancillary.TfaDetails?.DescriptionDE || ancillary.Value
                : ancillary.Type === 'SEAT'
                ? ancillary.Value
                : ancillary.Description ?? ''
            )}
          </>
        }
        extraStyle={{
          display: 'flex',
        }}
        color={
          ancillary.Note === 'ATCOM' || ancillary.Type === 'SEAT' || ancillary.Type === 'INF' || isNdc
            ? 'color-functional-neutral-900'
            : 'color-functional-neutral-400'
        }
      />
      <TFFTypography
        size="small"
        text={isNdc ? 'incl.' : costFormatter.format(ancillary?.TotalAmount! ?? 0)}
      />
    </div>
  );
};

export default AncillaryRow;
